import React from 'react';

// Custom icon component - Clean rendering with rounded corners
const CustomIcon = ({ src, alt, className = '', size = 24 }) => {
  return (
    <img 
      src={src} 
      alt={alt}
      className={className}
      style={{ 
        width: `${size}px`, 
        height: `${size}px`,
        objectFit: 'contain',
        display: 'block',
        filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.08))',
        borderRadius: '16px' // Rounded corners for modern look
      }}
    />
  );
};

// Icon URLs - All 512×512 transparent background PNGs — served locally
const ICON_URLS = {
  submitRequest: '/assets/icon-submit.png',
  trackPet:      '/assets/icon-track.png',
  materials:     '/assets/icon-materials.png',
  rewards:       '/assets/icon-rewards.png',
  cashValue:     '/assets/icon-cashvalue.png',
  totalReferrals:'/assets/icon-referrals.png',
  baselineCredit:'/assets/icon-baseline.png',
  totalRedeemed: '/assets/icon-redeemed.png'
};

// Individual icon exports
export const SubmitRequestIcon = ({ size = 24, className = '' }) => (
  <CustomIcon src={ICON_URLS.submitRequest} alt="Submit Request" size={size} className={className} />
);

export const TrackPetIcon = ({ size = 24, className = '' }) => (
  <CustomIcon src={ICON_URLS.trackPet} alt="Track Pet" size={size} className={className} />
);

export const MaterialsIcon = ({ size = 24, className = '' }) => (
  <CustomIcon src={ICON_URLS.materials} alt="Materials" size={size} className={className} />
);

export const RewardsIcon = ({ size = 24, className = '' }) => (
  <CustomIcon src={ICON_URLS.rewards} alt="Rewards" size={size} className={className} />
);

export const CashValueIcon = ({ size = 24, className = '' }) => (
  <CustomIcon src={ICON_URLS.cashValue} alt="Cash Value" size={size} className={className} />
);

export const TotalReferralsIcon = ({ size = 24, className = '' }) => (
  <CustomIcon src={ICON_URLS.totalReferrals} alt="Total Referrals" size={size} className={className} />
);

export const BaselineCreditIcon = ({ size = 24, className = '' }) => (
  <CustomIcon src={ICON_URLS.baselineCredit} alt="Baseline Credit" size={size} className={className} />
);

export const TotalRedeemedIcon = ({ size = 24, className = '' }) => (
  <CustomIcon src={ICON_URLS.totalRedeemed} alt="Total Redeemed" size={size} className={className} />
);

export default {
  SubmitRequestIcon,
  TrackPetIcon,
  MaterialsIcon,
  RewardsIcon,
  CashValueIcon
};
